import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const ChannelView = () => {
  const { id } = useParams(); // Get channel ID from the URL
  const URL = process.env.REACT_APP_API_URL;
  const [channel, setChannel] = useState(null);

  useEffect(() => {
    axios.get(`${URL}/channels/${id}`, {
          withCredentials: true,
        })
      .then((response) => {
        if (response.data && response.data.data) {
          setChannel(response.data.data);
        } else {
          toast.error("Channel not found");
        }
      })
      .catch(() => toast.error("Failed to fetch channel details"));
  }, [URL, id]);

  if (!channel) {
    return <div>Loading...</div>;
  }

  return (
    <div>      
      <h2 className="text-xl font-bold mb-4">การจัดการช่องทางการรับรู้</h2>
      <hr></hr>   

      <nav className="flex mt-4 mb-10" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li className="inline-flex items-center">
            <a href="/panel/channel" className="inline-flex items-center font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
              <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
              </svg>
              ช่องทางการรับรู้
            </a>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
              </svg>
              <span className="ms-1 font-medium text-gray-500 md:ms-2 dark:text-gray-400">แสดงข้อมูล</span>
            </div>
          </li>
        </ol>
      </nav>

      
      <div className="border border-gray-300 rounded p-4">        
        <p><strong>ชื่อช่องทาง:</strong> {channel.channelName}</p>
      </div>
    </div>
  );
};

export default ChannelView;